import { useContext } from 'react';

import { OrgRoleStaffRoleHierarchyStateContext } from './OrgRoleStaffRoleHierarchyContextProvider';
import OrgRoleStaffRoleHierarchyData from './OrgRoleStaffRoleHierarchyData';

import { DEFAULT_ID } from '../../utils/Constants';

const useOrgRoleStaffRoleHierarchyData = () => {
  const [orgRoleStaffRoleHierarchyState, setOrgRoleStaffRoleHierarchyState] = useContext(OrgRoleStaffRoleHierarchyStateContext);

  const getOrgRolesStaffRolesHierarchy = (roleGroupId) => OrgRoleStaffRoleHierarchyData.getOrgRolesStaffRolesHierarchy(roleGroupId, orgRoleStaffRoleHierarchyState, setOrgRoleStaffRoleHierarchyState);

  const clearOrgRolesStaffRolesHierarchyData = () => {
    setOrgRoleStaffRoleHierarchyState({
      ...orgRoleStaffRoleHierarchyState,
      isArrayLoading: false,
      isArrayLoaded: false,
      isSaving: false,
      isSaved: false,
      arrayData: [],
      message: '',
      roleGroupId: DEFAULT_ID,
      treeData: [],
      treeDataNoRegistrationRoles: [],
      treeDataNoRegistrationRolesWithoutChildren: []
    });
  };

  return {
    orgRoleStaffRoleHierarchyState,
    getOrgRolesStaffRolesHierarchy,
    clearOrgRolesStaffRolesHierarchyData
  };
};

export default useOrgRoleStaffRoleHierarchyData;